import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { RecoveryRenewalsWorkspace } from '@/components/organisms/recovery-renewals/RecoveryRenewalsWorkspace';
import type { RecoveryRenewalsSearch } from '@/components/organisms/recovery-renewals/recovery-renewals-model';
import { Fullbleed } from '@/contexts/fullbleed';

/**
 * NOT-567 — the "Recovery & Renewals" workspace was split. Past due is the
 * dunning half (failed payments, unpaid balances, suspended accounts); the
 * renewals half moved into the Memberships page as a tab.
 */
export const Route = createFileRoute('/_dashboard/dashboard/past-due')({
  validateSearch: (search: Record<string, unknown>): RecoveryRenewalsSearch => ({
    q: typeof search.q === 'string' ? search.q : '',
    type:
      search.type === 'JOB' || search.type === 'MEMBERSHIP'
        ? (search.type as RecoveryRenewalsSearch['type'])
        : 'ALL',
    status:
      search.status === 'ACTIVE' || search.status === 'PAST_DUE' || search.status === 'SUSPENDED'
        ? (search.status as RecoveryRenewalsSearch['status'])
        : 'ALL',
    renewalFilter: 'ALL',
    page:
      typeof search.page === 'number' && Number.isFinite(search.page) && search.page > 0
        ? Math.floor(search.page)
        : 1,
  }),
  component: PastDuePage,
});

function PastDuePage() {
  const navigate = useNavigate();
  const search = Route.useSearch();

  const onSearchChange = (patch: Partial<RecoveryRenewalsSearch>) => {
    void navigate({
      to: '/dashboard/past-due',
      // Any filter change resets to page 1; pagination passes an explicit page.
      search: { ...search, ...patch, page: patch.page ?? 1 },
      replace: true,
    });
  };

  return (
    <>
      <Fullbleed />
      <RecoveryRenewalsWorkspace
        mode="recovery"
        search={search}
        onSearchChange={onSearchChange}
        title="Past due"
        description="Failed payments, unpaid balances, and suspended accounts"
      />
    </>
  );
}
